/**
 * Created by ivo on 06.05.14.
 */

define([
    'common',
    'jQuery',
    './widgetFactory',
    'clientComponents/accordion/accordion',
    'clientComponents/request/multiRequestHandlerExtended',
    'library/fcse-state/Scope',
    'library/fcse-state/urlHandling',
    'clientComponents/countbutton/countButtonExtended',
    'library/fcse-visibilitycontrol/visibilityControl',
    'clientComponents/breadcrumbs/breadcrumbs',
    'clientComponents/ajaxcontentloader/ajaxContentLoader',
    'clientComponents/lazyimage/lazyImage',
    'clientComponents/state/stateHandler',
    'clientComponents/accordion/accordionStateHandler',
    'clientComponents/map/mapModal',
    'library/fcse-util/url',
    'clientComponents/seasonfallback/seasonFallback',
    'clientComponents/usersearchprefill/userSearchPrefillTracker',
    'clientComponents/googletagmanager/GtmManager'
],
    function (
        common,
        $,
        WidgetFactory,
        Accordion,
        MultiRequestHandler,
        Scope,
        UrlHandling,
        CountButton,
        VisibilityControl,
        Breadcrumbs,
        AjaxContentLoader,
        LazyImage,
        StateHandler,
        AccordionStateHandler,
        MapModal,
        Url,
        SeasonFallback,
        UserSearchPrefillTracker,
        GtmManager
    ) {
        var params = {};
        var url = new Url();

        if (typeof window.productSearchParams !== 'undefined') {
            params = window.productSearchParams;
        }
        // Create scopes
        var rootScope = new Scope(null, null, null, params);
        var localScope = new Scope(rootScope);
        localScope.setParam('bookingType', 'hotel');

        // Remove hotel related data from scope if header search used
        if (url.query.searchField == 'search-widget') {
            rootScope.setMultipleParams({
                'hotelName': null,
                'hotelId': null,
                'giataId': null
            });
        }

        // Create widget factory
        var widgetFactory = new WidgetFactory({rootScope: rootScope, localScope : localScope});

        // Enable URL History
        if (typeof history.pushState != 'undefined') {
            UrlHandling.enableBrowserHistory(rootScope);
        }

        // Initialize MultiRequestHandler
        var requestHandler = new MultiRequestHandler();

        // Initialize BreadCrumbs
        var breadcrumbs = new Breadcrumbs();

        widgetFactory.get('destinationWidget').dispatchEvent("change");

        // Remove hotel related data from scope if header search used
        /*if (url.query.searchField == 'search-widget') {
            rootScope.setMultipleParams({
                'hotelName': '',
                'hotelId': null,
                'giataId': null
            });
            localScope.setMultipleParams({
                'hotelName': '',
                'hotelId': null,
                'giataId': null
            });
        }*/

        if (url.query.searchValue && url.query.hotelName && url.query.hotelId) {
            rootScope.setMultipleParams({
                'searchValue': url.query.searchValue,
                'hotelName': url.query.hotelName,
                'hotelId': url.query.hotelId
            });
            localScope.setMultipleParams({
                'searchValue': url.query.searchValue,
                'hotelName': url.query.hotelName,
                'hotelId': url.query.hotelId
            });
        }

        var stateHandler = StateHandler.getInstance();
        stateHandler.addHandler(new AccordionStateHandler('ac', {
            requestHandler: requestHandler,
            nodeContentRoute: 'allt_frontend.hotel.destination.accordion_offers'
        }));

        // Initialize accordion
        var accordion = new Accordion(requestHandler, rootScope, {
            nodeContentRoute: 'allt_frontend.hotel.destination.accordion_offers',
            nodeDetailsRoute: 'allt_frontend.hotel.destination.accordion_detail',
            contentRoute: 'allt_frontend.hotel.destination.accordion_content'
        });

        var ajaxLoader = new AjaxContentLoader('[data-fcse-role="modal-trigger"]', rootScope, {
            'onshow': function(lightboxNode) {
                LazyImage.loadImages(lightboxNode);
                var visibilityControl = new VisibilityControl($('[data-fcse-role="visibility-control"]', lightboxNode),{
                    'targetIsVisibleClass': 'is-active',
                    'targetIsHiddenClass': 'is-collapsed'
                });
            }
        });

        // Initialize Button
        var countButton = new CountButton(requestHandler, rootScope, '[data-fcse-role="countbutton"]', {
            updateRoute: 'allt_frontend.hotel.update_count',
            /* queryUpdater: function(queryParams) {
                var hotelSearch = widgetFactory.get('searchmaskSearchWidget').getValue();
                if (!hotelSearch.hotelName) {
                    delete queryParams['hotelId'];
                    delete queryParams['giataId'];
                    delete queryParams['hotelName'];
                    delete queryParams['searchField'];
                    delete queryParams['searchValue'];
                } else {
                    queryParams['hotelName'] = hotelSearch.hotelName;
                    if (hotelSearch.hotelId) {
                        queryParams['hotelId'] = hotelSearch.hotelId;
                    }
                    queryParams['searchField'] = 'searchmask-search-widget';
                    queryParams['searchValue'] = hotelSearch.hotelName;
                }
                return queryParams;
            } */
        });
        new VisibilityControl('[data-searchmask-toggle]', {
            'targetSelectorAttribute': 'data-searchmask-toggle',
            'elementTargetIsVisibleClass': 'is-active',
            'targetIsVisibleClass': 'is-toggled',
            'targetIsHiddenClass': 'is-not-active'
        });

        // Add VisibilityControl
        var visibilityControl = new VisibilityControl('[data-fcse-role="visibility-control"]', {
            'targetIsVisibleClass': 'is-active',
            'targetIsHiddenClass': 'is-collapsed'
        });

        // Update breadcrumbs on successful getting data
        accordion.on("dataSuccess", function(data) {
            if (data && data.meta && data.meta.breadcrumbs) {
                breadcrumbs.update(data.meta.breadcrumbs)
            }
        });
        MapModal.getInstance($('body > [data-fcse-role="map-modal"]'), requestHandler, {});

        if (!_.isUndefined(url.query.showmap) && url.query.showmap == 'true') {
            var mapOpenButton = $('[data-fcse-role="map-overlay-open-button"]:first', this.element);

            if (mapOpenButton.length){
                mapOpenButton.click();
            }
        }

        var seasonFallback = new SeasonFallback(
            requestHandler,
            'allt_frontend.hotel_content_season_fallback',
            [
                'allt_frontend.package.destination.accordion_offers',
                'allt_frontend.package.destination.accordion_content'
            ]
        );

        var searchPrefill = new UserSearchPrefillTracker();
        searchPrefill.registerScope(rootScope);

        try{
            let pageType = $('[data-gtm-page-type]').data('gtm-page-type');
            if (!pageType) {
                pageType = 'listingPage';
            }

            GtmManager
                .setOptions({scope: rootScope, stateHandler: requestHandler})
                .initPageTracker('listingPage', {
                    country: $('[data-page-locale]').first().data('page-locale'),
                    pageType: pageType,
                    siteArea: 'hotelDestination'
                });
        } catch (e) {
            console.log(e);
        }

        stateHandler.applyState();
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/hotel/destination/index.js